

const NoPage = () => {
    return (<>
        <div>Content not found</div>
    </>)
}

export default NoPage;